import commonJsModule from "has-content"

export const {isEmpty} = commonJsModule
export default commonJsModule.default